<div class="min-h-screen bg-slate-50 font-['DM_Sans',sans-serif]">
  <div class="max-w-8xl mx-auto px-6 py-8">
    <div class="mb-8 animate-fade-in-down">
      <app-page-header
        title="Vendor Management"
        subtitle="Manage and monitor all registered vendors"
      ></app-page-header>
    </div>

    <div
      class="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden animate-fade-in-up"
    >
      <div
        class="flex flex-col lg:flex-row lg:items-center justify-between gap-4 px-6 py-5 border-b border-slate-100"
      >
        <div class="flex w-full flex-col sm:flex-row sm:items-center gap-3">
          <div class="relative w-full sm:w-[520px]">
            <svg
              class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            <button
              type="button"
              (click)="openFilters()"
              class="w-full pl-9 pr-4 py-2 text-sm bg-slate-50 border border-slate-200 rounded-lg text-left text-slate-700 focus:outline-none focus:ring-2 focus:ring-teal-500/30 focus:border-teal-500 transition-all duration-200"
            >
              {{
                activeFilterCount
                  ? activeFilterCount +
                    " active filter" +
                    (activeFilterCount > 1 ? "s" : "")
                  : "Search and filter vendors"
              }}
            </button>
          </div>

          <button
            type="button"
            (click)="exportCurrentTableAsCsv()"
            class="flex items-center justify-center gap-2 px-4 py-2 page-btn page-btn-outline active:scale-95 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 3v12m0 0l3-3m-3 3l-3-3m6 6H6"
              />
            </svg>
            Export
          </button>
        </div>

        @if (authenticationService.hasAnyPermission(["CAN_CREATE_Vendor_Management"])) {
          <div class="flex w-full lg:w-auto justify-end">
            <button
              type="button"
              (click)="openAddVendorWizard()"
              class="flex items-center gap-2 px-5 py-2.5 page-btn page-btn-primary active:scale-95 text-sm font-medium transition-all duration-200 whitespace-nowrap"
            >
              <span class="text-lg leading-none">+</span>
              Add Vendor
            </button>
          </div>
        }
      </div>

      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead>
            <tr class="bg-slate-50/70">
              <th
                *ngFor="let col of columns"
                class="px-6 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap select-none"
                [class.text-left]="col !== 'Actions'"
                [class.text-center]="col === 'Actions'"
              >
                {{ col }}
              </th>
            </tr>
          </thead>

          <tbody class="divide-y divide-slate-100">
	            <tr *ngIf="isLoadingVendors">
	              <td colspan="8" class="px-6 py-16 text-center">
	                <div class="flex flex-col items-center gap-3">
	                  <div
	                    class="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-vms-bg-secondary"
	                  ></div>
                  <p class="text-sm font-medium text-slate-500">
                    Loading vendors...
                  </p>
                </div>
              </td>
            </tr>

            <ng-container *ngIf="!isLoadingVendors">
              <tr
                *ngFor="let vendor of vendors; let i = index"
                class="relative group hover:bg-teal-50/30 transition-colors duration-150 animate-row-in"
                [style.animation-delay]="i * 60 + 'ms'"
                [style.z-index]="vendors.length - i"
              >
                <td class="px-6 py-4 font-medium text-slate-700 whitespace-nowrap">
                  {{ vendor.vendorReference || vendor.id }}
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-left">
                  <div class="font-medium text-slate-800">
                    {{ vendor.name }}
                  </div>
                  <div class="text-xs text-slate-400 mt-0.5">
                    RC - {{ vendor.rcNumber || 'N/A' }}
                  </div>
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-slate-700">
                  {{ vendor.asin || 'N/A' }}
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-slate-700">
                  {{ vendor.mdaName || 'N/A' }}
                </td>

                <td class="px-6 py-4 whitespace-nowrap">
                  <span
                    class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-slate-50 text-slate-600 border border-slate-100"
                  >
                    {{ vendor.categoryName || 'N/A' }}
                  </span>
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-slate-700">
                  {{ vendor.vendorType || 'N/A' }}
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-slate-700">
                  {{ vendor.applicationStatus || 'N/A' }}
                </td>

                <td class="px-6 py-4 whitespace-nowrap">
                  <span
                    class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium"
                    [ngClass]="getStatusPillClass(vendor.approvalStatus)"
                  >
                    {{ vendor.approvalStatus || 'PENDING' }}
                  </span>
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-center relative vendor-actions">
                  <app-dropdown-menu>
                    <button
                      type="button"
                      class="inline-flex h-8 w-8 items-center justify-center rounded-lg text-slate-500 hover:text-slate-700 hover:bg-slate-100 transition-colors duration-150"
                      aria-label="Vendor actions"
                      trigger
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          d="M6 10a2 2 0 11-4 0 2 2 0 014 0zm8 0a2 2 0 11-4 0 2 2 0 014 0zm6 0a2 2 0 11-4 0 2 2 0 014 0z"
                        />
                      </svg>
                    </button>
                    
                    @if (authenticationService.hasAnyPermission(["CAN_VIEW_Vendor_Management", "CAN_EDIT_Vendor_Management"])) {
                      <ng-container content>
                        @if (authenticationService.hasAnyPermission(["CAN_VIEW_Vendor_Management"])) {
                          <button
                            type="button"
                            (click)="onViewDetails(vendor)"
                            class="w-full px-4 py-3 text-sm font-medium bg-vms-bg-secondary text-vms-text-secondary flex items-center gap-2"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              />
                            </svg>
                            View Details
                          </button>
                        }
      
                        @if (authenticationService.hasAnyPermission(["CAN_EDIT_Vendor_Management"])) {
                          <button
                            *ngIf="(vendor.approvalStatus || '').toUpperCase() !== 'APPROVED'"
                            type="button"
                            (click)="openEditVendorWizard(vendor)"
                            class="w-full px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 flex items-center gap-2"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-4 w-4 text-slate-500"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                              />
                            </svg>
                            Edit
                          </button>
                        }
                        <!-- Temporarily hidden (per request): Deactivate / Blacklist actions -->
                      </ng-container>
                    }
                  </app-dropdown-menu>
                </td>
              </tr>

              <tr *ngIf="vendors.length === 0">
                <td colspan="6" class="px-6 py-16 text-center">
                  <div class="flex flex-col items-center gap-3">
                    <div
                      class="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 text-slate-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.5"
                          d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <p class="text-sm font-medium text-slate-500">
                      No vendors found
                    </p>
                    <p class="text-xs text-slate-400">
                      Try adjusting your search or status filter
                    </p>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <div
        class="flex items-center justify-between px-6 py-4 border-t border-slate-100 bg-slate-50/50"
      >
        <p class="text-xs text-slate-400">
          Showing {{ vendors.length }} of {{ totalItems }} vendors
        </p>
        <div class="flex items-center gap-1">
          <button
            (click)="goToPreviousPage()"
            [disabled]="!hasPreviousPage"
            class="px-3 py-1.5 text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-md transition-colors duration-150 disabled:opacity-40"
          >
            Previous
          </button>
          <button
            class="px-3 py-1.5 text-xs bg-vms-bg-secondary text-vms-text-secondary rounded-md shadow-sm"
          >
            {{ currentPage }}
          </button>
          <button
            (click)="goToNextPage()"
            [disabled]="!hasNextPage"
            class="px-3 py-1.5 text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-md transition-colors duration-150 disabled:opacity-40"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-vendor-details-modal
  [open]="isDetailsModalOpen"
  [vendor]="selectedVendor"
  [loading]="isLoadingVendorDetails"
  (close)="closeDetailsModal()"
></app-vendor-details-modal>

<app-filter-drawer
  [isOpen]="isFilterDrawerOpen"
  title="Filters"
  subtitle="Search and filter vendors."
  submitLabel="Apply Filters"
  resetLabel="Clear all"
  [fields]="vendorFilterFields"
  [initialValue]="vendorFilters"
  (close)="closeFilters()"
  (apply)="applyFilters($event)"
></app-filter-drawer>
